/*

 _      _       _    _                _
| |    (_)     | |  | |              | |
| |     _ _ __ | | _| |     ___   ___| | _____ _ __
| |    | | '_ \| |/ | |    / _ \ / __| |/ / _ | '__|
| |____| | | | |   <| |___| (_) | (__|   |  __| |
|______|_|_| |_|_|\_|______\___/ \___|_|\_\___|_|

=======================*============================

FetchLinks.js


*/

// Auto-Refresh Links

if (document.querySelector('.links')) {

  // create object which sets / clears intervals
  const manageIntervals = {
    intervals: new Set(),

    make(...args) {
      let newInterval = setInterval(...args);
      this.intervals.add(newInterval);
      return newInterval;
    },
    clear(id) {
      this.intervals.delete(id);
      return clearInterval(id);
    },
    clearAll() {
      for (let id of this.intervals) {
        this.clear(id);
      }
    },
  };

  // Set a flag on click events that we can check for in
  // the focus handler. This allows us to avoid sending the
  // fetch event when a click is the cause of a focus event
  window.addEventListener('click', () => {
    if (!document.querySelector('body').classList.contains('active')) {
      appSettings.clickFlag === false ? appSettings.clickFlag = true : null;
    }
  });

  // Set class on body element when active, fetch link data
  // immediately, and set the timer
  window.addEventListener('focus', () => {
    setTimeout(() => {
      if (appSettings.clickFlag === true) {
        document.querySelector('body').classList.add('active');
        if (!linkEditorIsLive()) {
          document.dispatchEvent(appSettings.customEvents.fetchReadyEvent);
          appSettings.clickFlag === false;
        }
      } else if (appSettings.clickFlag === false) {
        if (!linkEditorIsLive()) {
          document.dispatchEvent(appSettings.customEvents.fetchReadyEvent);
        }
      }
    }, 250)
  });

  // Remove active class on body on blur event, and
  // clear the fetch timer
  window.addEventListener('blur', () => {
    document.querySelector('body').classList.remove('active');
    manageIntervals.clearAll();
    appSettings.clickFlag === false;
  });

  // Fetch link data
  async function getLinksAJAX() {
    let fetchURL = new URL(window.location.href);
    fetchURL.searchParams.append('fetch', 'true');

    let links = await fetch(fetchURL)
      .then((response) => response.text())
      .then((data) => {
        return data;
      });

    return JSON.parse(links);
  }

  // Check last updated entry in DB
  async function checkLastUpdate() {
    let pageIsActive = document
      .querySelector('body')
      .classList.contains('active');
    let editorIsHidden =
      document.querySelector('[name="activeEditor"]') === null;
    let bulkEditorIsHidden =
      document.querySelector('#bulk-edit-controls').style.display !== 'flex';
    if (pageIsActive && editorIsHidden && bulkEditorIsHidden) {
      let update = await fetch('/last-update')
        .then((response) => response.text())
        .then((data) => {
          return data;
        });

      return JSON.parse(update);
    }
  }

  // Update DOM with Link Data
  document.addEventListener('ready-to-fetch', async () => {
    const parent = document.querySelector('.links #linklist');
    const tokenTag = document.querySelector('meta[name="csrf-token"]');
    const fetched_links = await getLinksAJAX();
    const { token, links, user_settings } = fetched_links;

    // update CSRF token
    tokenTag.content = token;
    appSettings.csrfToken = token;

    // Clear existing links first
    parent.innerHTML = '';

    // Process each link element
    for (let link of links) {
      // Fallback for uncategorized links
      const category =
        link.category.length > 0 ? link.category : 'uncategorized';

      // Pre-build tags
      const tags = () => {
        let tagsLinks = '';
        if (link.tags.length > 0) {
          for (let tag of link.tags) {
            tagsLinks += `
							<a class="tag" href="/tag/${tag}" title="Tag: ${tag}">${tag}</a>
						`;
          }
        }
        return tagsLinks;
      };

      // Generate 'mark as read' link for link-footer, if needed
      const markAsReadLink = (link) => {
        if (link.readlater) {
          return `
						<div class="read-toggle" id="read-${link.id}">
						 <a href="" class="mark-read">mark as read</a>
						</div>
					`;
        } else {
          return '';
        }
      };

      // Assemble the link element
      const linkElement = `
				<li id="link-${link.id}" class="link-li${link.readlater ? ' readlater-link' : ''}">
				
					<div class="link-header ${user_settings.link_display_settings.star || user_settings.link_display_settings.category ? '' : 'hidden'}">
					
						<span class="star ${user_settings.link_display_settings.star ? '' : 'hidden'}">
							<a id="star-${link.id}" title="star" aria-label="star" href="" onclick="setStar('${link.id}'); return false;">${link.starred}</a>
						</span>
						
						<a href="/category/${category}" title="Category: ${category}" id="link_category-${link.id}" class="category ${user_settings.link_display_settings.category ? '' : 'hidden'}">
							<span>${category}</span>
						</a>
						
					</div>
					
					<div class="bulk-edit-selector">
						<label for="bulk-edit-${link.id}">Delete? </label>
						<input type="checkbox" id="bulk-edit-${link.id}" name="bulk-edit-${link.id}" class="bulk-edit-checkbox">
					</div>
					
					<div class="link-body">
						<span id="link_title-${link.id}" class="link_title">
							<a href="${link.link}" target="${user_settings.open_links_in_new_tab ? '_blank' : '_self'}">${htmlEncode(link.title)}</a>
						</span>
						
						<span title="${link.ts}" class="ts ${user_settings.link_display_settings.timestamp.show_timestamp ? '' : 'hidden'} ${user_settings.link_display_settings.timestamp.relative_timestamp ? '' : 'in-utc'}">${link.ts}</span>
						
						<span id="description-${link.id}" class="description ${user_settings.link_display_settings.description ? '' : 'hidden'}">${htmlEncode(link.description)}</span>
						
						<div id="tags-${link.id}">
							<div class="tags ${user_settings.link_display_settings.tags ? '' : 'hidden'}">
								${tags()}
							</div>
						</div>
					</div>
					
					<div class="link-footer">
						<div class="edit-button">
							<a href="" onclick="showEditForm('${link.id}'); return false;">edit</a> 
						</div>
						<div class="delete-button">
							<a id="delete-${link.id}" class="outer-delete" href="" onclick="deleteLinkConfirm('${link.id}'); return false;">delete</a>
							<span id="delete-confirmation-${link.id}" class="delete-confirmation">
								 — Are you sure?
								<a href="" class="delete-it" onclick="deleteIt('${link.id}'); return false">Yes</a>.
							</span>
						</div>
			
						${markAsReadLink(link)}
						
					</div>
					<br />
				</li>
			`;

      // pop the link element into the <ul> element
      parent.insertAdjacentHTML('beforeend', linkElement);
    }

    // keep `ul#linklist` classes in sync with settings
    (() => {
      const linkList = document.querySelector('ul#linklist');
      const condensed = user_settings.link_display_settings.single_line_mode;

      const simple =
        user_settings.link_display_settings.single_line_mode &&
        !user_settings.link_display_settings.star &&
        !user_settings.link_display_settings.category &&
        !user_settings.link_display_settings.timestamp.show_timestamp &&
        !user_settings.link_display_settings.description &&
        !user_settings.link_display_settings.tags;

      if (condensed === true && !linkList.classList.contains('condensed')) {
        linkList.classList.add('condensed');
      } else if (
        condensed === false &&
        linkList.classList.contains('condensed')
      ) {
        linkList.classList.remove('condensed');
      }

      if (simple === true && !linkList.classList.contains('simple')) {
        linkList.classList.add('simple');
      } else if (simple === false && linkList.classList.contains('simple')) {
        linkList.classList.remove('simple');
      }
    })();

    // refresh the timestamps
    timestampFmt();

    // Re-init readlater event listeners
    setReadLaterEventListeners();

    // Init timer
    fetchTimer()
  });

  // check every so often (see app settings) for last update,
  // fetch links if updated less than a minute ago
  const fetchTimer = () => {
    // get timer interval from app settings
    const interval = appSettings.linkRefreshTimer;

    manageIntervals.clearAll();
    manageIntervals.make(async () => {
      let updated = await checkLastUpdate();
      let now = new Date();
      updated = new Date(await updated.last_updated);
      let lastFetched = now.setSeconds(now.getSeconds() - interval);
      if (lastFetched < (await updated)) {
        document.dispatchEvent(appSettings.customEvents.fetchReadyEvent);
      }
    }, 1 * interval * 1000);
  };

  // kick off the initial timer
  window.addEventListener('DOMContentLoaded', () => {
    fetchTimer();
  });
}
